/**
 * Which Felix chat session ids this tab has actually saved to the server.
 *
 * Row bc96f3f0 (founder #3615 6110353854, item L). FelixChat mints a random
 * session id per tab and, on every mount with an empty local history, asked
 * the server for that session. An id is only ever saved by the tab that minted
 * it, so for a new tab -- the meeting lobby opened from an invitation, a page
 * before the first message -- the answer was always 404: four of them in the
 * 10-11 dry run's lobby alone (12:59:04, 13:02:05, 13:03:15, 13:04:53).
 *
 * The marker lives in sessionStorage beside the id itself, so a duplicated
 * tab (which copies sessionStorage) keeps both and still restores.
 */
const PREFIX = "felix_chat_session_saved_";

export function markChatSessionSaved(sessionId: string): void {
  try {
    sessionStorage.setItem(PREFIX + sessionId, "1");
  } catch {
    /* storage unavailable: the next mount simply does not restore */
  }
}

export function chatSessionWasSaved(sessionId: string): boolean {
  try {
    return sessionStorage.getItem(PREFIX + sessionId) === "1";
  } catch {
    return false;
  }
}
